import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Único filtro que se mantiene: el aviso de `aria-hidden` que MUI provoca al
// abrir/cerrar diálogos. Cualquier otro warning o error debe llegar a la consola.
const esRuidoAriaHidden = (args) =>
  typeof args[0] === 'string' && args[0].includes('aria-hidden');

const originalWarn = console.warn;
const originalError = console.error;

console.warn = (...args) => {
  if (esRuidoAriaHidden(args)) return;
  originalWarn.apply(console, args);
};

console.error = (...args) => {
  if (esRuidoAriaHidden(args)) return;
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 